/**
 * A file size the way a person reads it: "834 KB", "2,4 MB".
 *
 * Lived twice, identically, in two mail components; the calendar needed it as a
 * third. One copy, so a change to how a size reads happens once.
 *
 * Deliberately binary units (1024) and the European decimal comma — the whole app
 * formats numbers that way (docs/design.md, rule 7).
 */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
}

const KILOS = new Intl.NumberFormat("nl-NL", { maximumFractionDigits: 0 });
const METRES = new Intl.NumberFormat("nl-NL", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/**
 * A weight on the lists of the Planbord and the trips: whole kilos, "18.789", "227" for 226,98 (testronde 28-10-2026,
 * punt 8). Only how it reads: the stored value keeps its decimals.
 */
export function formatKg(value: number): string {
  return KILOS.format(Math.round(value) || 0);
}

/** Loading metres there: always one decimal, "8,0", "13,2", "0,0" for 0,01 — as the trip sheet of TALIS writes them. */
export function formatLdm(value: number): string {
  return METRES.format(Math.round(value * 10) / 10 || 0);
}
